module.exports = __webpack_public_path__ + "static/media/logo.c5826765.svg";